const consumeList = {
    path: 'consumeList',
    component: resolve => require(['@/pages/admin/businessmag/consume'], resolve)
}

export default consumeList